var version = {
    "name":      "dativery",
    "buildDateCode": "20260525-153500",
    "buildDate": "Mon May 25 2026 15:35:00 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260525-153500",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;